import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal, SectionTag } from "./motion";
import { wa } from "../lib/site";

const stats = [
  { value: "+15", label: "anos de experiência" },
  { value: "18", label: "passageiros na Sprinter" },
  { value: "3", label: "países em uma viagem" },
];

export default function SobreMagnus() {
  return (
    <section id="sobre" className="py-24 md:py-32 bg-sand" data-testid="sobre-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
        <div className="relative">
          <Reveal>
            <div className="rounded-3xl overflow-hidden aspect-[4/3] max-w-xl">
              <motion.img
                src="https://customer-assets-7cd3h4nn.emergentagent.net/job_cataratas-experienza/artifacts/0cqoq0dp_WhatsApp%20Image%202026-08-31%20at%2011.47.13-2.jpeg"
                alt="Magnus Máximo com a Sprinter em frente às Cataratas do Iguaçu"
                className="w-full h-full object-cover"
                initial={{ scale: 1.15 }}
                whileInView={{ scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
              />
            </div>
          </Reveal>
          <Reveal delay={0.25} className="absolute -bottom-8 left-4 md:left-8">
            <div className="rounded-2xl bg-brand text-white px-6 py-5 shadow-2xl">
              <p className="font-display font-extrabold text-2xl leading-none">Magnus Máximo</p>
              <p className="text-[11px] uppercase tracking-widest text-white/70 mt-1.5">Guia de turismo em Foz do Iguaçu</p>
            </div>
          </Reveal>
        </div>

        <div className="pt-10 lg:pt-0">
          <Reveal>
            <SectionTag>Sobre o Magnus</SectionTag>
            <h2 className="mt-5 font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.08] text-brand-deep text-balance">
              Prazer, eu sou o <span className="font-serif italic font-medium text-brand-light">Magnus!</span>
            </h2>
            <p className="mt-3 text-brand-light font-semibold text-sm uppercase tracking-[0.2em]">
              Guia de turismo em Foz do Iguaçu há mais de 15 anos
            </p>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="mt-8 space-y-5 text-moss leading-relaxed text-base md:text-lg">
              <p>
                Minha história com o turismo começou há mais de 15 anos e, desde então, tenho o privilégio de acompanhar pessoas que chegam a Foz do Iguaçu para conhecer uma das regiões mais incríveis do Brasil.
              </p>
              <p>
                Conheço os principais destinos da região e meu objetivo é fazer com que você aproveite sua viagem com tranquilidade, conforto e segurança.
              </p>
              <p>
                Hoje, conto também com uma Sprinter para até 18 passageiros, oferecendo uma estrutura confortável para famílias, grupos de amigos e excursões.
              </p>
              <p className="text-ink font-medium">
                Mais do que levar você aos destinos, quero fazer parte de uma viagem que você vai lembrar para sempre.
              </p>
              <p className="font-serif italic text-2xl text-brand-deep">— Magnus Máximo</p>
            </div>
          </Reveal>

          <Reveal delay={0.2}>
            <div className="mt-10 flex flex-wrap gap-4" data-testid="sobre-stats">
              {stats.map((s) => (
                <div key={s.label} className="rounded-2xl border border-brand/10 bg-white px-6 py-4">
                  <p className="font-display font-extrabold text-2xl text-brand">{s.value}</p>
                  <p className="text-xs text-moss mt-1">{s.label}</p>
                </div>
              ))}
            </div>
            <a
              href={wa("Olá, Magnus! Vi sua história no site e quero conversar sobre minha viagem para Foz do Iguaçu.")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="sobre-cta-button"
              className="group mt-8 inline-flex items-center gap-2 rounded-full bg-brand px-8 py-4 text-sm font-bold text-white transition-transform duration-300 hover:scale-[1.04] shadow-lg shadow-brand/25"
            >
              Conversar com o Magnus
              <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
